import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import { PrivateRoute } from '../../../auth'
import { DEFAULT_ROLES } from '../../../../common/core/_consts'
import SystemSettingsList from './components/settings-list/SystemSettingsList'

const SystemSettingsPage: React.FC = () => {
  return (
    <Routes>
        <Route element={<Outlet />}>
            <Route
                index
                element={
                    <PrivateRoute roles={DEFAULT_ROLES} >
                        <SystemSettingsList />
                    </PrivateRoute>
                }
            />
        </Route>
    </Routes>
  )
}

export default SystemSettingsPage
